// 权限管理
import http from '@/jslibs/axios/http';

// 登录
export const login = data => http.post('/v1/cms/Login', data);

